function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { Icon } from "@chakra-ui/icon";
import { Box } from "@chakra-ui/layout";
import { chakra, useMultiStyleConfig } from "@chakra-ui/system";

var MultiValue = props => {
  var {
    children,
    className,
    components,
    cx,
    data,
    innerProps,
    isDisabled,
    isFocused,
    removeProps,
    selectProps
  } = props;
  var {
    Container,
    Label,
    Remove
  } = components;
  var {
    chakraStyles,
    colorScheme,
    tagVariant,
    size
  } = selectProps;
  var extraData = data;
  var {
    container,
    closeButton,
    label
  } = useMultiStyleConfig("Tag", {
    size,
    colorScheme: extraData.colorScheme || colorScheme,
    variant: extraData.variant || tagVariant || (extraData.isFixed ? "solid" : "subtle")
  });

  var containerInitialStyles = _objectSpread(_objectSpread({
    display: "inline-flex",
    verticalAlign: "top",
    alignItems: "center",
    maxWidth: "100%"
  }, container), {}, {
    margin: "0.125rem"
  });

  var containerSx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.multiValue ? chakraStyles.multiValue(containerInitialStyles, props) : containerInitialStyles;
  var labelSx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.multiValueLabel ? chakraStyles.multiValueLabel(label, props) : label;

  var removeInitialStyles = _objectSpread({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, closeButton);

  var removeSx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.multiValueRemove ? chakraStyles.multiValueRemove(removeInitialStyles, props) : removeInitialStyles;
  return /*#__PURE__*/React.createElement(Container, {
    data: data,
    innerProps: _objectSpread({
      className: cx({
        "multi-value": true,
        "multi-value--is-disabled": isDisabled
      }, className)
    }, innerProps),
    sx: containerSx,
    selectProps: selectProps
  }, /*#__PURE__*/React.createElement(Label, {
    data: data,
    innerProps: {
      className: cx({
        "multi-value__label": true
      }, className)
    },
    sx: labelSx,
    selectProps: selectProps
  }, children), /*#__PURE__*/React.createElement(Remove, {
    data: data,
    innerProps: _objectSpread({
      className: cx({
        "multi-value__remove": true
      }, className),
      "aria-label": "Remove ".concat(children || "option")
    }, removeProps),
    sx: removeSx,
    selectProps: selectProps,
    isFocused: isFocused
  }));
};

var MultiValueContainer = props => {
  var {
    children,
    innerProps,
    sx
  } = props;
  return /*#__PURE__*/React.createElement(chakra.span, _extends({}, innerProps, {
    sx: sx
  }), children);
};

var MultiValueLabel = props => {
  var {
    children,
    innerProps,
    sx
  } = props;
  return /*#__PURE__*/React.createElement(chakra.span, _extends({}, innerProps, {
    sx: sx
  }), children);
};
/**
 * Borrowed from Chakra UI Tag source
 *
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/13c6d2e08b61e179773be4722bb81173dd599306/packages/tag/src/tag.tsx#L75}
 */


var TagCloseIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  verticalAlign: "inherit",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
}));

var MultiValueRemove = props => {
  var {
    children,
    innerProps,
    isFocused,
    data,
    sx
  } = props;
  var extraData = data;

  if (extraData.isFixed) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Box, _extends({}, innerProps, {
    role: "button",
    sx: sx,
    "data-focus": isFocused ? true : undefined
  }), children || /*#__PURE__*/React.createElement(TagCloseIcon, null));
};

export { MultiValueContainer, MultiValueLabel, MultiValueRemove };
export default MultiValue;
//# sourceMappingURL=multi-value.js.map